module.exports = __webpack_public_path__ + "static/media/notarize.2d3c5a38.png";